import * as React from 'react';
import { Outlet } from 'react-router-dom';

const Raffle: React.FC = () => {
  return <Outlet />;
};

export default Raffle;
